
export class SurveyResponse  {
    _id: string;
    _kmd: any;
    SurveyName: string;
    QuestionNumber: number;
    QuestionName: string;
    Values: any[];
}
